function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import './index.scss';

const Loader = ({
  active,
  fixed,
  noTransition,
  children,
  size,
  hasSpinner,
  transparent,
  className,
  ...props
}) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(active);
  }, [active]);
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: show,
    timeout: 150,
    classNames: {
      enter: '',
      enterActive: 'show',
      enterDone: 'show',
      exit: '',
      exitActive: '',
      exitDone: ''
    },
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classNames("loader-spinner", {
      'no-transition': noTransition,
      fixed,
      transparent
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: "loader-content"
  }, hasSpinner && /*#__PURE__*/React.createElement(Spinner, {
    animation: "border",
    size: size,
    variant: "secondary"
  }), children)));
};

Loader.defaultProps = {
  hasSpinner: true
};
export default Loader;